import { BaseApiRequest } from '@api/BaseApi';

export const createBaseline = (body) => {
  return BaseApiRequest(null, `/Baseline/Create`, 'gpr', 'POST', body);
};

export const fetchBaselineById = (body) => {
  return BaseApiRequest(null, `/Baseline/GetByBaselineId`, 'gpr', 'POST', body);
};

export const updateBaseline = (body) => {
  return BaseApiRequest(null, `/Baseline/Update`, 'gpr', 'PUT', body);
};

export const deleteBaseline = ({ baselineId }) => {
  return BaseApiRequest(null, `/Baseline/Delete`, 'gpr', 'DELETE', { baselineId });
};

export const getBaselineViewSettings = (signal, { userId }) => {
  return BaseApiRequest(signal, `/BaselineViewSettings/Get`, 'gpr', 'POST', { userId });
};

export const createBaselineViewSettings = (body) => {
  return BaseApiRequest(null, `/BaselineViewSettings/Create`, 'gpr', 'POST', body);
};

export const updateBaselineViewSettings = (body) => {
  let newBody = { ...body };
  newBody.baselineViewSettingsId = body.graphDisplays[0].viewSettingsId;
  return BaseApiRequest(null, `/BaselineViewSettings/Update`, 'gpr', 'PUT', newBody);
};
